import { Mat4Set } from "./DataTexture";
import { Context } from "../Engine";
import { ColladaAnimation } from "@spi/Common/Animation";
import { AnimationDataTexture } from "./AnimationDataTexture";

export class ColladaAnimationDataTexture extends AnimationDataTexture {
    constructor(ctx: Context, public animation: ColladaAnimation) {
        super(ctx);

        this.setFrameData();
    }

    public getFrameOffset(clipId: string, frameIndex: number): number {
        return this.getOffset(this.formatOffsetKey(clipId, frameIndex));
    }

    private formatOffsetKey(clipId: string, frameIndex: number) {
        return `${clipId}/frame${frameIndex}`;
    }

    private setFrameData() {
        let data: Mat4Set[] = [];

        // Bone 1-frame1, Bone 2-frame1, Bone 3-frame1

        for (let clip of this.animation.clips) {
            let clipLength = this.animation.clipLength[clip.id];

            for (let frameIndex = 0; frameIndex < clipLength; frameIndex++) {

                data.push({
                    key: this.formatOffsetKey(clip.id, frameIndex),
                    matrices: this.animation.joints.map(joint => joint.animationFrames[clip.id][frameIndex].worldMatrix)
                });
            }
        }
        this.setMat4Data(data);
    }
}